// extracted by mini-css-extract-plugin
export default {"information_table":"Staff_information_table__yUF2Q"};